import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "@/components/LanguageSwitcher";

export function AuthHeader() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className="relative h-44 overflow-hidden">
      <img
        src="https://static.prod-images.emergentagent.com/jobs/a7ba0871-0fe0-4d76-aa98-64efe9fe0979/images/cb6279fc8de7e502454c41a78ad8dcdb923f94d77094273a8590ec066cf4b242.png"
        alt=""
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-[#1B4332]/55" />
      <button
        data-testid="back-btn"
        onClick={() => navigate("/")}
        className="absolute top-4 left-4 h-10 w-10 rounded-full bg-white/20 backdrop-blur flex items-center justify-center text-white"
      >
        <ArrowLeft className="h-5 w-5" />
      </button>
      <div className="absolute top-4 right-4">
        <LanguageSwitcher />
      </div>
      <div className="absolute bottom-4 left-5">
        <h1 className="font-display text-2xl font-extrabold text-white">SuccèsNet</h1>
        <p className="text-white/80 text-sm">{t("auth.tagline")}</p>
      </div>
    </div>
  );
}
